import dust1Icon from "@/img/warning-icon/dust-1-icon.svg";
import dust2Icon from "@/img/warning-icon/dust-2-icon.svg";
import dust3Icon from "@/img/warning-icon/dust-3-icon.svg";

import fog1Icon from "@/img/warning-icon/fog-1-icon.svg";
import fog2Icon from "@/img/warning-icon/fog-2-icon.svg";
import fog3Icon from "@/img/warning-icon/fog-3-icon.svg";

import frost1Icon from "@/img/warning-icon/frost-1-icon.svg";
import frost2Icon from "@/img/warning-icon/frost-2-icon.svg";
import frost3Icon from "@/img/warning-icon/frost-3-icon.svg";
import frost4Icon from "@/img/warning-icon/frost-4-icon.svg";

import hail1Icon from "@/img/warning-icon/hail-1-icon.svg";
import hail2Icon from "@/img/warning-icon/hail-2-icon.svg";
import hail3Icon from "@/img/warning-icon/hail-3-icon.svg";
import hail4Icon from "@/img/warning-icon/hail-4-icon.svg";

import highTemperature1Icon from "@/img/warning-icon/high-temperature-1-icon.svg";
import highTemperature2Icon from "@/img/warning-icon/high-temperature-2-icon.svg";
import highTemperature3Icon from "@/img/warning-icon/high-temperature-3-icon.svg";
import highTemperature4Icon from "@/img/warning-icon/high-temperature-4-icon.svg";

import highWave1Icon from "@/img/warning-icon/high-wave-1-icon.svg";
import highWave2Icon from "@/img/warning-icon/high-wave-2-icon.svg";
import highWave3Icon from "@/img/warning-icon/high-wave-3-icon.svg";
import highWave4Icon from "@/img/warning-icon/high-wave-4-icon.svg";

import rainfall1Icon from "@/img/warning-icon/rainfall-1-icon.svg";
import rainfall2Icon from "@/img/warning-icon/rainfall-2-icon.svg";
import rainfall3Icon from "@/img/warning-icon/rainfall-3-icon.svg";
import rainfall4Icon from "@/img/warning-icon/rainfall-4-icon.svg";

import thunderstorm1Icon from "@/img/warning-icon/thunderstorm-1-icon.svg";
import thunderstorm2Icon from "@/img/warning-icon/thunderstorm-2-icon.svg";
import thunderstorm3Icon from "@/img/warning-icon/thunderstorm-3-icon.svg";
import thunderstorm4Icon from "@/img/warning-icon/thunderstorm-4-icon.svg";

import wind1Icon from "@/img/warning-icon/wind-1-icon.svg";
import wind2Icon from "@/img/warning-icon/wind-2-icon.svg";
import wind3Icon from "@/img/warning-icon/wind-3-icon.svg";
import wind4Icon from "@/img/warning-icon/wind-4-icon.svg";

export const iconsWithColor: Record<string, string> = {
	"dust-1-icon.svg": dust1Icon,
	"dust-2-icon.svg": dust2Icon,
	"dust-3-icon.svg": dust3Icon,

	"fog-1-icon.svg": fog1Icon,
	"fog-2-icon.svg": fog2Icon,
	"fog-3-icon.svg": fog3Icon,

	"frost-1-icon.svg": frost1Icon,
	"frost-2-icon.svg": frost2Icon,
	"frost-3-icon.svg": frost3Icon,
	"frost-4-icon.svg": frost4Icon,

	"hail-1-icon.svg": hail1Icon,
	"hail-2-icon.svg": hail2Icon,
	"hail-3-icon.svg": hail3Icon,
	"hail-4-icon.svg": hail4Icon,

	"high-temperature-1-icon.svg": highTemperature1Icon,
	"high-temperature-2-icon.svg": highTemperature2Icon,
	"high-temperature-3-icon.svg": highTemperature3Icon,
	"high-temperature-4-icon.svg": highTemperature4Icon,

	"high-wave-1-icon.svg": highWave1Icon,
	"high-wave-2-icon.svg": highWave2Icon,
	"high-wave-3-icon.svg": highWave3Icon,
	"high-wave-4-icon.svg": highWave4Icon,

	"rainfall-1-icon.svg": rainfall1Icon,
	"rainfall-2-icon.svg": rainfall2Icon,
	"rainfall-3-icon.svg": rainfall3Icon,
	"rainfall-4-icon.svg": rainfall4Icon,

	"thunderstorm-1-icon.svg": thunderstorm1Icon,
	"thunderstorm-2-icon.svg": thunderstorm2Icon,
	"thunderstorm-3-icon.svg": thunderstorm3Icon,
	"thunderstorm-4-icon.svg": thunderstorm4Icon,

	"wind-1-icon.svg": wind1Icon,
	"wind-2-icon.svg": wind2Icon,
	"wind-3-icon.svg": wind3Icon,
	"wind-4-icon.svg": wind4Icon,
};

export const getWarningIconByValueAndLayer = ({
	value,
	event,
}: {
	value: number;
	event: string;
}) => {
	const baseLayer = event.replace("_dw", "").replaceAll("_", "-");

	return iconsWithColor[`${baseLayer}-${value}-icon.svg`] ?? "";
};

export const getColorStatusByColor = (value: number): string => {
	let hexColor = "";

	switch (value) {
		case 1:
			hexColor = "#25B24A";
			break;
		case 2:
			hexColor = "#F1C40F";
			break;
		case 3:
			hexColor = "#EC8826";
			break;
		case 4:
			hexColor = "#E74C3C";
			break;

		default:
			null;
	}

	return hexColor;
};
